var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"gapRadioGroupRef"},[(_setup.options?.length)?_vm._l((_setup.options),function(item){return _c('span',{key:item[_setup.valueKey],staticClass:"gap-radio-item",class:[
        _setup.activeValue === item[_setup.valueKey] ? 'gap-radio-item__active' : '',
        _setup.needMarginBottom(item) ? 'mb-24' : ''
      ],style:({
        width: _setup.fixWidth ? _setup.fixWidth + 'px' : 'auto'
      }),attrs:{"disabled":item[_setup.disabledKey]},on:{"click":function($event){return _setup.radioClick(item)}}},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(item[_setup.labelKey])+" ")]},{"row":item})],2)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }